import React, { Component } from 'react';
import resources from '../../resources';
import TextSection from '../BaseComponents/TextSection';
import TextSection2 from '../BaseComponents/TextSection2';
import TextSectionWithStructuredBullets from '../BaseComponents/TextSectionWithStructuredBullets';
import ImageBulletedSection from '../BaseComponents/ImageBulletedSection';
import StoreManager from '../../appdata';
import languages from '../../appdata/languages';

class ManagementReportContent2 extends Component {
  render() {
    
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].ManagementReportContent2;
     const {isMobile} = StoreManager.appState.thisApp.state
    
    return (
      <div>
          <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 500, marginBottom: 24 }}>
          {content.title}
        </h2>
        <TextSection title={content.section1Title} paragraphs={content.section1TextArray} />
          <img
                    src={lang == 'vi'? resources.images.ManagementReport2Image1_vi:resources.images.ManagementReport2Image1}
                    style={{width: '100%',
                      borderRadius: 8,
                      objectFit: 'cover'}}
                  />
        <TextSection2 title={content.section2Title} paragraphs={content.section2TextArray} padding={0}/>

        <TextSection title={content.section3Title} paragraphs={content.section3TextArray} />
        <img
                    src={lang == 'vi'? resources.images.ManagementReport2Image2_vi:resources.images.ManagementReport2Image2}
                    style={{width: '100%',
                      borderRadius: 8,
                      objectFit: 'cover'}}
                  />
        <TextSection2 title={content.section4Title} paragraphs={content.section4TextArray} padding={0}/>
        <TextSection title={content.section5Title} paragraphs={content.section5TextArray} />

      </div>
    );
  }
}

export default ManagementReportContent2;
